
import { Component, Mixins } from "vue-property-decorator";
import {
  IUserDefinitionItem,
} from "../../../../../domain/document/items";
import {
  UserDefinitionSelectResult,
} from "../../dialogs";
import { CommonComponentsAccessor } from "../../CommonComponentsAccessor";

@Component
export default class UserDefinitionSelectableMixin extends Mixins() {
  editingSource: IUserDefinitionItem;
  commonComponents: CommonComponentsAccessor;

  async selectUserDefinition(): Promise<void> {
    const editor = this.commonComponents.editors.userDefinition;
    const initialFilterParameters = editor.getInitialFilterParameters(this.editingSource);

    const dialog = this.commonComponents.dialogs.userDefinition.selector;
    const result = await dialog.show(this.editingSource, initialFilterParameters);
    await this.applySelectedUserDefinition(this.editingSource, result);
  }

  private async applySelectedUserDefinition(source: IUserDefinitionItem, result: UserDefinitionSelectResult): Promise<void> {
    const editor = this.commonComponents.editors.userDefinition;
    await editor.applySelectedInformation(source, result);
    await this.$nextTick();
    const extraPageEditor = this.commonComponents.editors.extraPage;
    if (extraPageEditor.isAddibleOverflowedTextPage(this.editingSource)) {
      extraPageEditor.addOverflowedTextPage(this.editingSource);
    }
  }
}
